import CustomerSearchBox from './customer-search-box';

export default CustomerSearchBox;
